// Dynamic styles based on theme - to be used with useThemedStyles.
export const createPendingStockCreateReturnDialogStyles = ({ ui: { colors, type, space, radius } }) => ({
	dialogScroll: {
		flexGrow: 0,
		flexShrink: 1,
	},
	dialogContent: {
		paddingBottom: space.sm,
	},
	dialogTitle: {
		...type.cardTitle,
		color: colors.text,
		marginBottom: space.sm,
		paddingRight: space.xxl,
	},
	dialogMeta: {
		...type.bodySmall,
		color: colors.textSecondary,
		marginBottom: space.sm,
	},
	inputLabel: {
		...type.fieldLabel,
		color: colors.text,
		marginBottom: space.xs,
		marginTop: space.sm,
	},
	batchRow: {
		borderWidth: 1,
		borderColor: colors.border,
		borderRadius: radius.card,
		backgroundColor: colors.card,
		padding: space.md,
		marginTop: space.sm,
		gap: space.sm,
	},
	batchHeading: {
		...type.overline,
		color: colors.textSecondary,
	},
	batchDate: {
		marginTop: space.xs,
	},
	batchFooter: {
		marginTop: space.md,
		gap: space.sm,
	},
	batchTotal: {
		...type.secondary,
		color: colors.textSecondary,
	},
	warningText: {
		...type.bodySmallSemibold,
		color: colors.warning,
		marginTop: space.sm,
		marginBottom: space.xs,
	},
	errorText: {
		...type.bodySmallSemibold,
		color: colors.danger,
		marginTop: space.sm,
		marginBottom: space.xs,
	},
	dialogActions: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: space.sm,
		marginTop: space.md,
	},
	dialogActionButton: {
		flexGrow: 1,
		flexBasis: 120,
	},
});
